export default {
      id: "color_smile-usage",
      viewBox: "0 0 71 59",
      url: __webpack_public_path__ + "sprite.svg#color_smile",
      toString: function () {
        return this.url;
      }
    }